import { LDFlagSet } from 'launchdarkly-js-sdk-common';

/**
 * REMINDER: when updating this list, please also update "LDFlagSet" interface
 * within "types/launchdarkly-js-sdk-common.d.ts" file (drives flag type)
 *
 * We should look to improve process of setting flag types and defaults.
 * Initially basing off of below (dated) issue on one avenue of managing this.
 * https://github.com/launchdarkly/js-sdk-common/issues/32
 *
 * One key downfall of this method is that it doesn't prevent users to add / access
 * flags that aren't inluded in the type. So if type doesn't include "unavailable",
 * compiler won't complain about "flags.unavailable" (it'll treat it as "any" type),
 * or any lingering flags as well.
 * This possibly may be resolved once we update our LD package version.
 *
 * Note: at the moment, we use a single instance of LaunchDarkly for both our
 * "admin" and "core" apps, implying that both apps technically have access to
 * the same flags. If we do split up LD usage, should also split this structure
 */
export const launchDarklyFeatureFlags: LDFlagSet = {
  assignByStrategy: false,
  assignByIndividualReceivable: false,
  borrowerS3Upload: false,
  displayAssignment: false,
  displayPortfolioCovenants: false,
  showBorrowerReceivableDashboard: false,

  enableManualUploaderOnly: false,
  hideManualUploader: false,
  creditFacilitySlugsToHide: [],

  isStatementsMonthlySummaryEnabled: false,
  displayLenderPortfolioMonitoringCovenants: false,
  displayLenderPortfolioMonitoringReceivables: false,

  showLenderPortfolioStrats: 'hide',
  showStratsPage: 'hide',

  showExploReportBuilder: false,

  displayLenderSettingsFacilities: false,

  enableLenderBaseFieldEdits: false,

  displayGoldmanSachsBackdoorDownloadRouter: true,

  isBorrowerLimitedOrganization: false,
  lenderOwnerOrganizationWithBorrowerLimited: false,

  showV4Deliverables: false,

  isValleyBankLenderView: false,

  targetHeaderValue: '',

  isAthenaEnabled: false,
  isExcelEngineAdvanceRateEnabled: false,
};
